import { X } from "lucide-react";

export const labelCls = "block text-sm font-semibold text-navy mb-2";
export const inputCls =
    "w-full border border-line bg-white px-4 py-3.5 text-base text-navy outline-none focus:border-gold transition-colors placeholder:text-slate-400";
export const btnPrimary =
    "inline-flex items-center justify-center gap-2 bg-navy text-white px-8 py-4 text-base font-semibold hover:bg-gold transition-colors disabled:opacity-50";
export const btnGhost =
    "inline-flex items-center justify-center gap-2 border border-line px-6 py-4 text-base font-semibold text-charcoal hover:border-navy transition-colors";

export const Modal = ({ title, onClose, children, wide }) => (
    <div className="fixed inset-0 z-[100] bg-navy/60 backdrop-blur-sm overflow-y-auto" data-testid="modal-overlay">
        <div className={`bg-white w-full ${wide ? "max-w-3xl" : "max-w-xl"} mx-auto my-6 md:my-12 border border-line shadow-2xl`}>
            <div className="flex items-center justify-between px-6 py-5 border-b border-line sticky top-0 bg-white z-10">
                <h3 className="font-heading font-bold text-2xl text-navy tracking-tight">{title}</h3>
                <button onClick={onClose} className="p-2.5 hover:bg-bone border border-line" data-testid="modal-close-button" aria-label="Close">
                    <X size={20} />
                </button>
            </div>
            <div className="p-6">{children}</div>
        </div>
    </div>
);
